import React from 'react';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import MainContent from './MainContent';
import { FilterDate } from './filter-date';
import { IndexSummary } from './index-summary';
import { connect } from 'react-redux';
import {
  fetchInfoTypeSearchTicker,
  fetchListDataTable,
  REDUCER_NAME,
  subscribeRealtimeIndex,
  subscribeRealtimeTick,
} from './reducer';
import SizeTracker from '../../../common/size-tracker/SizeTracker';
import { I18n } from 'react-redux-i18n';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class MarketAnomaly extends AutoReloadOnFocusBlurComponent {
  reload() {
    const { fetchInfoTypeSearchTicker, fetchListDataTable } = this.props;
    fetchInfoTypeSearchTicker();
    fetchListDataTable();
  }

  componentDidMount() {
    super.componentDidMount();
    const { fetchInfoTypeSearchTicker, fetchListDataTable } = this.props;
    fetchInfoTypeSearchTicker();
    fetchListDataTable();
    this.subscribeRealtime();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentSearch } = this.props;
    if (currentSearch.isTicker === prevProps.currentSearch.isTicker) {
      return;
    }
    this.unsubscribeRealtime(prevProps.currentSearch);
    this.subscribeRealtime();
  }

  componentWillUnmount() {
    const { currentSearch } = this.props;
    this.unsubscribeRealtime(currentSearch);
    super.componentWillUnmount();
  }

  subscribeRealtime = () => {
    const { currentSearch } = this.props;
    if (currentSearch.isTicker) {
      MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    } else {
      MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  unsubscribeRealtime = currentSearch => {
    if (currentSearch.isTicker) {
      MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
    } else {
      MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  onReceiveIndex = data => {
    const { currentSearch, subscribeRealtimeIndex } = this.props;
    const index = data.find(item => item.comGroupCode === currentSearch.code);
    if (index) {
      subscribeRealtimeIndex(this.formatIndexPrice(index));
    }
  };

  formatIndexPrice = index => {
    return {
      ...index,
      matchPrice: index.indexValue,
      priceChange: index.indexChange,
      percentPriceChange: index.percentIndexChange,
      referencePrice: index.referenceIndex,
      floorPrice: 0,
      ceilingPrice: 0,
    };
  };

  onReceiveTicker = data => {
    const { currentSearch, subscribeRealtimeTick } = this.props;
    const ticker = data.find(item => item.organCode === currentSearch.code);
    if (ticker) {
      subscribeRealtimeTick(ticker);
    }
  };

  render() {
    return (
      <SizeTracker className="market-anomaly tab-pane active d-flex flex-fill flex-column">
        {(width, height) => (
          <div style={{ width, height }}>
            <div className="chart-view-wrap px-20 d-flex flex-column flex-fill h-100">
              <div className="d-flex">
                <div className="w-185px">
                  <IndexSummary />
                </div>
                <div className="w-100-185px">
                  <FilterDate />
                </div>
              </div>
              <MainContent />
            </div>
          </div>
        )}
      </SizeTracker>
    );
  }
}

const mapStateToProps = state => ({
  currentSearch: state[REDUCER_NAME].currentSearch,
});

const mapDispatchToProps = {
  fetchInfoTypeSearchTicker,
  fetchListDataTable,
  subscribeRealtimeTick,
  subscribeRealtimeIndex,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarketAnomaly);
